<ng-container *ngIf="barcode$ | async as barcode">
  <div class="barcode p-0 d-flex flex-wrap flex-column justify-content-around align-items-center">
    <ng-container *ngIf="card$ | async as card">
      <ng-container *ngIf="member$ | async as member">
        <!-- Not Owner Barcode Body -->
        <div class="w-100 bg-primary barcode-content-container">
          <div class="barcode-content text-white d-flex flex-column" *ngIf="card$ | async as card">
            <div class="info-box">
              <!--Name and ID-->

              <div class="font-size-14 text-uppercase font-page-heading fw-bold" *ngIf="memberDetails$ | async as memberDetails">
                {{ memberDetails.FirstName + ' ' + memberDetails.Surname }}
              </div>
              <div class="d-flex productcode font-size-12">
                <div>{{ card.ProductCode | accountMembership | translate }}</div>
                <div class="px-1">-</div>
                <div>{{ card.MemberId }}</div>
              </div>
            </div>
            <button
              *ngIf="showWallet"
              class="d-flex align-items-center justify-content-center btn bg-black text-white font-heading mt-3 w-100 font-size-14"
              [routerLink]="['/rewards/wallet']"
            >
              <span class="material-icons me-2 font-size-20 text-center walleticon">qr_code_2 </span>
              {{ 'nav.wallet' | translate }}
            </button>
          </div>
          <div *ngIf="showBarcode">
            <div class="qr">
              <div>
                <qrcode [qrdata]="barcode.Barcode" [width]="127" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
                <p class="font-size-12 text-black d-flex flex-wrap">
                  {{ 'wallet.barcode.scan' | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #loading>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
